import { useCallback, useState } from 'react';

import type { CmsApiPageId } from 'modules/cms/api/types/CmsApiTypedId';
import { getCmsTotalReactionsText } from 'modules/cms/helpers/reactions/getCmsTotalReactionsText';
import { CmsShowAllReactionsModalContainerLoadable } from 'modules/cms/modals/ShowAllReactions/CmsShowAllReactionsModalContainerLoadable';

import {
  CmsTotalReactionsHeadingButton,
  CmsTotalReactionsHeadingPlaceholder,
} from './CmsReactionButton.styled';
import { useCmsReactionsContext } from './CmsReactionsContext';

type Props = {
  contentId: CmsApiPageId;
};

export function CmsTotalReactionsHeading({ contentId }: Props) {
  const [showAllReactionsModal, setShowAllReactionsModal] = useState(false);
  const close = useCallback(() => setShowAllReactionsModal(false), []);

  const { totalReactions } = useCmsReactionsContext();

  const headingText = getCmsTotalReactionsText(totalReactions);

  return (
    <>
      {totalReactions > 0 ? (
        <CmsTotalReactionsHeadingButton
          type="button"
          onClick={() => setShowAllReactionsModal(true)}
          data-qa-id="cms-total-reactions-heading-button"
        >
          {headingText}
        </CmsTotalReactionsHeadingButton>
      ) : (
        <CmsTotalReactionsHeadingPlaceholder>
          {headingText}
        </CmsTotalReactionsHeadingPlaceholder>
      )}

      {showAllReactionsModal && (
        <CmsShowAllReactionsModalContainerLoadable
          contentId={contentId}
          onClose={close}
        />
      )}
    </>
  );
}
